import { Type } from '../const';

export const initData = {
	[Type.Tabs]: [],
	[Type.Subtabs]: [],
	[Type.Roles]: [],
};

export const initIsUpdated = {
	[Type.Tab]: false,
	[Type.Subtab]: false,
	[Type.Role]: false,
};
